var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',[_c('v-col',{attrs:{"cols":"4"}},[_c('v-card',{staticClass:"anamnese-statistics__add-question"},[_c('v-responsive',{attrs:{"aspect-ratio":1 / 1}},[_c('v-card-title',[_vm._v("Frage hinzufügen")])],1)],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }